'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _splitUpdater = require('./splitUpdater');

var _splitUpdater2 = _interopRequireDefault(_splitUpdater);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function stateSpliter(state, updater) {
  return function linkState(key, init) {
    var _ref;

    var stateName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
    var updaterName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'onChange';
    var _state$key = state[key],
        subState = _state$key === undefined ? init : _state$key;

    return _ref = {}, _defineProperty(_ref, stateName, subState), _defineProperty(_ref, updaterName, (0, _splitUpdater2.default)(updater)(key)), _ref;
  };
}

exports.default = stateSpliter;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/stateSpliter.js
// module id = 1665
// module chunks = 0